import { render, staticRenderFns } from "./aboutquestion.vue?vue&type=template&id=73e5e71b&scoped=true"
import script from "./aboutquestion.vue?vue&type=script&lang=js"
export * from "./aboutquestion.vue?vue&type=script&lang=js"
import style0 from "./aboutquestion.vue?vue&type=style&index=0&id=73e5e71b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e5e71b",
  null
  
)

export default component.exports